import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { InternalFilterGroup, FilterChange, FilterItem } from 'app/shared/models/filter-group.models';
import { UtilityFunctions } from 'app/shared/utilities/functions.models';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'app-input-filter',
    templateUrl: './input-filter.component.html',
    styleUrls: ['./input-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InputFilterComponent implements OnChanges {

  @Input() filter: InternalFilterGroup;
  @Input() dataToView: FilterItem[] = [];
  @Output() change = new EventEmitter<FilterChange>();

  filterOptions = new BehaviorSubject<FilterItem[]>([]);

  utilsFunction = UtilityFunctions;

  constructor(
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.dataToView) {
      this.filterOptions.next(this.dataToView);
    }
  }

  onChange(group: InternalFilterGroup) {
    group.data = this.filterOptions.value;
  }

}
